import { defineMeta } from '@/registry/types';

export const settingsExampleMeta = defineMeta({
  name: 'SettingsExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference settings page (SettingsLayout + FormSection + FormField).',
  baseLibrary: 'custom',
  importPath: '@/pages/SettingsExample',
  supportedStates: ['default'],
  designTokens: ['spacing', 'typography'],
  usageExamples: ['<SettingsExample />'],
  llmSafe: false,
  whenToUse: ['Reference for settings screens'],
  whenNotToUse: ['Production without data wiring'],
});

export default settingsExampleMeta;
